import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import { TopicSupporterVoices } from './api.graphql';
import type { TopicSupporterVoicesQuery, TopicSupporterVoicesQueryVariables } from './api.graphql';
import type { TopicPageSupporterVoices } from './types';

export async function getData({ gql: { fetch } }: UtilityContext, slug: string): Promise<TopicPageSupporterVoices> {
	const { data } = await fetch<TopicSupporterVoicesQuery, TopicSupporterVoicesQueryVariables>({
		query: TopicSupporterVoices,
		variables: { slug },
		rejectOnError: true,
	});

	const supporterVoices = data.topicPageBySlug?.supporterVoices;

	if (!supporterVoices) {
		throw new NotFoundError();
	}

	return supporterVoices;
}
